import { useState } from "react";
import styled from "styled-components";
import { RequestedClassCardInstructor } from "ui/base/class/RequestedClassCardInstructor";
import { NoContent } from "ui/base/NoContent/NoContent";
import { hideScrollBar } from "ui/base/scrollbarStyle/scrollbarStyle";
import NoClassRequestFound from "ui/icons/not-found-icons/noRequest.svg";
import { UserProfileModal } from "ui/base/class/UserProfileModal";
import { fonts } from "ui/theme";
import { AcceptModal } from "./AcceptModal";
import { DeclineModal } from "./DeclineModal";
import { NoPayoutMethod } from "./NoPayoutMethod";
import { useAuth } from "context/AuthContext";

export const RequestedClasses = ({ requestedClasses, classType, onSendMessage }) => {
    const { userData } = useAuth()
    const [showAcceptModal, setShowAcceptModal] = useState(false);
    const [showDeclineModal, setShowDeclineModal] = useState(false);
    const [showNoPayoutMethod, setShowNoPayoutMethod] = useState(false);
    const [showUserProfile, setShowUserProfile] = useState(false);
    const [selectedClass, setSelectedClass] = useState(null);

    return (
        <>
            {selectedClass && showAcceptModal ? (
                <AcceptModal
                    show={showAcceptModal}
                    selectedClass={selectedClass}
                    handleClose={() => {
                        setSelectedClass(null);
                        setShowAcceptModal(false);
                    }}
                />
            ) : null}

            {selectedClass && showUserProfile ? (
                <UserProfileModal
                    show={showUserProfile}
                    handleClose={() => {
                        setSelectedClass(null);
                        setShowUserProfile(false);
                    }}
                    handleSendMessage={() => {
                        onSendMessage(selectedClass?.user?.id)
                        setShowUserProfile(false);
                        setSelectedClass(null);
                    }}
                    userId={selectedClass?.user?.id}
                    isInstructor
                />
            ) : null}

            {selectedClass && showDeclineModal ? (
                <DeclineModal
                    show={showDeclineModal}
                    selectedClass={selectedClass}
                    handleClose={() => {
                        setSelectedClass(null);
                        setShowDeclineModal(false);
                    }}
                />
            ) : null}

            <NoPayoutMethod
                show={showNoPayoutMethod}
                handleClose={() => {
                    setShowNoPayoutMethod(false);
                }}
            />

            <Content>
                <Title>Class Requests</Title>
                {requestedClasses?.length ?
                    <ClassList>
                        {requestedClasses?.map((requestedClass) => (
                            <RequestedClassCardInstructor
                                key={requestedClass.id}
                                classType={classType}
                                requestedClass={requestedClass}
                                onAccept={() => {
                                    if (userData?.teacher?.profile_completion === "50") {
                                        setShowNoPayoutMethod(true)
                                        return;
                                    }
                                    setSelectedClass(requestedClass);
                                    setShowAcceptModal(true);
                                }}
                                onDecline={() => {
                                    setSelectedClass(requestedClass);
                                    setShowDeclineModal(true);
                                }}
                                onProfile={() => {
                                    setSelectedClass(requestedClass);
                                    setShowUserProfile(true)
                                }}
                            />
                        ))}
                    </ClassList> :
                    <NoContent title='No class request found' image={NoClassRequestFound} size={280} />
                }
            </Content>
        </>
    );
};

const Content = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    overflow: scroll;

    ${hideScrollBar}
`;

const ClassList = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 0.8rem;

    @media (max-width: 768px) {
        grid-template-columns: repeat(1, 1fr);
    }
`;

const Title = styled.p`
    font-size: ${fonts.sizes.medium};
    font-weight: 600;
    text-align: left;
    text-transform: capitalize;

    @media (max-width: 1024px) {
        display: none;
    }
`;
